'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Lazy load framer-motion only on the client
const MotionDiv = dynamic(
  async () => {
    const { motion } = await import('framer-motion');
    return ({ children, ...props }) => (
      <motion.div {...props}>{children}</motion.div>
    );
  },
  { ssr: false }
);

export default function Template({ children }) {
  return (
    <MotionDiv
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: 'easeInOut', duration: 0.5 }}
    >
      {children}
    </MotionDiv>
  );
}
